import _get from 'lodash/get';
import { FULFILLMENT_TYPE_IN_STORE, FULFILLMENT_TYPE_SHIPPING, FULFILLMENT_PROVIDER_MERCHANT } from '../constants';
export function getDefaultFulfillmentTypeForOrder(order) {
  var availableFulfillmentTypes = _get(order, 'fulfillment_methods', []).map(function (method) {
    return method.type;
  });
  if (availableFulfillmentTypes.includes(FULFILLMENT_TYPE_IN_STORE)) {
    return FULFILLMENT_TYPE_IN_STORE;
  }
  return _get(availableFulfillmentTypes, '[0]', FULFILLMENT_TYPE_IN_STORE);
}
export function getFulfillmentProviderForOrder(order, fulfillmentType) {
  var fulfillmentMethods = _get(order, 'fulfillment_methods', []).filter(function (method) {
    return method.type === fulfillmentType;
  });
  if (fulfillmentMethods.length === 0) {
    // Default to merchant
    return FULFILLMENT_PROVIDER_MERCHANT;
  }
  return _get(fulfillmentMethods, '[0].provider', FULFILLMENT_PROVIDER_MERCHANT);
}
export function getFulfillmentDefaultRateAmount(order) {
  return _get(order, 'fulfillment.rates[0].total', 0);
}
export function getFulfillmentDefaultRateDuration(order, fulfillmentType) {
  var durationFieldName = fulfillmentType === FULFILLMENT_TYPE_SHIPPING ? 'duration_days' : 'duration_minutes';
  return _get(order, "fulfillment.rates[0].".concat(durationFieldName), 'N/A');
}